import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation, Outlet } from 'react-router-dom';
import { RootState } from '../app/store';

// Lazy load NotFound for access denied
const NotFound = React.lazy(() => import('../pages/NotFound'));

const AdminRoute: React.FC = () => {
  const location = useLocation();
  const { user, token } = useSelector((state: RootState) => state.auth);

  // Not logged in → redirect to regular login (shop admin uses /login)
  if (!token || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Only shop admin (role=admin) can access /admin/* routes
  // Superadmin has their own /super-admin/* routes
  if (user.role !== 'admin') {
    // Superadmin should go to their own dashboard
    if (user.role === 'superadmin') {
      return <Navigate to="/super-admin/dashboard" replace />;
    }
    // Regular shop users (cashier, manager, etc.) - show 404 page
    return (
      <Suspense fallback={<div></div>}>
        <NotFound />
      </Suspense>
    );
  }

  return <Outlet />;
};

export default AdminRoute;